module.exports = __webpack_public_path__ + "img/digitalocean.30fbc273.png";